import React, {Component} from 'react';
import UsersList from "../../components/UsersList/UsersList";
import Modal from 'react-modal';
import AddUser from "../../components/popups/AddUser";
import {connect} from "react-redux";
import {deleteUser, getCompanyUsers, setUserAdded, updateUser} from "../../store/actions/user";
import PropTypes from "prop-types";
import Alert from "../../components/popups/Alert";
import {toast} from 'react-toastify';

Modal.setAppElement('#root');

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalState: {
        modalIsOpen: false,
        confirmModalIsOpen: false
      },
      selectedUserId: null
    };
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  componentWillMount() {
    if (this.props.auth.user.role !== 'company') {
      this.props.history.push('/404');
    }
  }

  componentDidMount() {
    this.props.getCompanyUsers();
  }

  openModal(action, selectedUserId = null) {
    const modalState = {...this.state.modalState};

    switch (action) {
      case 'add':
        modalState.modalIsOpen = true;
        break;
      case 'delete':
        modalState.confirmModalIsOpen = true;
        break;
      default:
        break;
    }

    this.setState({
      modalState,
      selectedUserId
    });
  }

  closeModal(action, deleting = false, userAdded = false) {
    const modalState = {...this.state.modalState};

    switch (action) {
      case 'add':
        modalState.modalIsOpen = false;
        break;
      case 'delete':
        modalState.confirmModalIsOpen = false;
        break;
      default:
        break;
    }

    if (deleting) {
      this.props.deleteUser(this.state.selectedUserId);
    }

    if (userAdded) {
      toast.success('The invitation is sent successfully.', {
        position: toast.POSITION.TOP_RIGHT,
        className: ''
      });
    }

    this.setState({
      modalState,
      selectedUserId: null
    });

    this.props.setUserAdded(false);
  }

  toggleActivation(id, isActive) {
    this.props.updateUser(id, {is_active: !isActive});
  }

  render() {
    return (
        <main>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-content-center">
                    <h2>List of users</h2>
                    <button type="button" className="btn btn-primary btn-lg" data-target="" data-toggle="modal"
                            onClick={() => this.openModal('add')}>Add
                      users
                    </button>
                  </div>
                  <div className="card-body overflow-x">
                    <UsersList users={this.props.users}
                               toggleActivation={this.toggleActivation.bind(this)} openModal={this.openModal}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal isOpen={this.state.modalState.modalIsOpen} onRequestClose={() => this.closeModal('add')}
                 contentLabel="Add User Modal">
            <AddUser closeModal={this.closeModal}/>
          </Modal>
          <Modal isOpen={this.state.modalState.confirmModalIsOpen} onRequestClose={() => this.closeModal('delete')}
                 contentLabel="Delete User Modal">
            <Alert closeModal={this.closeModal}/>
          </Modal>
        </main>
    );
  }
}

Users.propTypes = {
  users: PropTypes.object.isRequired,
  getCompanyUsers: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
  setUserAdded: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  users: state.user.users,
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  getCompanyUsers: () => dispatch(getCompanyUsers()),
  updateUser: (id, userData) => dispatch(updateUser(id, userData)),
  deleteUser: id => dispatch(deleteUser(id)),
  setUserAdded: added => dispatch(setUserAdded(added))
});

export default connect(mapStateToProps, mapDispatchToProps)(Users);



// WEBPACK FOOTER //
// ./src/containers/Users/Users.jsx